export default "__VITE_ASSET__Cc9B4Wt1__"